export default __webpack_public_path__ + "static/media/WhatMakesUsDifferent.647b397b.jpg";